var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ApplicationStatus } from './ApplicationStatus';
export const ApplicationTitle = (_a) => {
    var { record } = _a, rest = __rest(_a, ["record"]);
    const classes = useStyles(rest);
    if (!record) {
        return null;
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", null,
            React.createElement("span", { className: classes.title }, record.name),
            React.createElement(ApplicationStatus, { classes: { status: classes.status }, record: record }))));
};
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    title: {},
    status: {
        padding: theme.spacing(1, 0),
    },
}), {
    name: 'Layer7ApplicationTitle',
});
//# sourceMappingURL=ApplicationTitle.js.map